import BgIconPrefix from './BgIconPrefix';
import BgStandard from './BgStandard';

const EXPORT = {
  BgIconPrefix,
  BgStandard,
};

export default EXPORT;
